export const patientDeleteReasons = [
  'Accidental Entry',
  'Duplicate Encounter',
  'Incorrect Patient',
  'Incorrect User',
  'Other'
];
